import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderWithPendingInvoiceComponent } from './order-with-pending-invoice.component';
import { PosTableModule } from '../pos-table/pos-table.module';



@NgModule({
  declarations: [
    OrderWithPendingInvoiceComponent
  ],
  imports: [
    CommonModule,
    PosTableModule
  ]
})
export class OrderWithPendingInvoiceModule { }
